<template>
  <div id="app">
    <transition name="fade">
      <router-view/>    
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
  },
  mounted() {
  }
}
</script>


<style lang="less">
  .size{
    width: 100%;
    height: 100%;
  }
  html,body{
    .size;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  #app {
    .size;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue